module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "ink-container"
    }
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "control-group"
  }, [_c('ul', {
    staticClass: "ink-list"
  }, [_vm._l((_vm.inks), function(ink) {
    return _c('li', [_c('label', {
      staticClass: "control control--checkbox"
    }, [_vm._v(_vm._s(ink.name) + "\n\t\t\t\t\t\t"), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (ink.selected),
        expression: "ink.selected"
      }],
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "checked": Array.isArray(ink.selected) ? _vm._i(ink.selected, null) > -1 : (ink.selected)
      },
      on: {
        "change": function($event) {
          var $$a = ink.selected,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(ink, "selected", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(ink, "selected", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(ink, "selected", $$c)
          }
        }
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "control__indicator"
    })])])
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary btn-xs pull-right",
    staticStyle: {
      "margin-top": "20px"
    },
    on: {
      "click": function($event) {
        return _vm.reload()
      }
    }
  }, [_vm._v("Reload")])], 2)])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-55d3cae1"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Inks.vue
// module id = 422
// module chunks = 1